<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Locações', 'link' : '/rental' }]"
    />
    <h1 class="text-center" v-if="operation === 'store'">Nova Locação</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Locação</h1>

    <!-- Formulário -->
    <form @submit.prevent="actionOperation" @keydown.enter.prevent v-if="!loading">
      <div class="row">
        <div class="col-2"></div>
        <div class="col-12 col-md-8">

          <!-- ===== ITENS ===== -->
          <div class="row mb-2">
            <h5 class="text-center mb-3">Itens:</h5>

            <div v-for="item in dados.listaitens" :key="item.id" class="col-6 col-md-3 p-1">
              <div class="rental-item-card">
                <img :src="item.foto_url" class="rental-item-img" alt="" />
                <div class="rental-item-body">
                  <p class="rental-item-name">{{ item.name }}</p>
                  <div class="rental-item-qty-row">
                    <button @click="removeItem(item.id)" type="button" class="rental-qty-btn rental-qty-btn--minus">−</button>
                    <input
                      @change="calcTotalItem($event, item.id)"
                      type="number"
                      :value="item.quant"
                      class="rental-qty-input"
                      :name="'quantItem-'+item.id"
                      :id="'quantItem-'+item.id"
                    />
                    <button @click="addItem(item.id)" type="button" class="rental-qty-btn rental-qty-btn--plus">+</button>
                  </div>
                  <div class="field">
                    <label for="inpTxtRentalState" class="field__label field__label--required">Tipo de Locação</label>
                    <select @change="calcValores($event, item.id)" v-model="item.rental_type" class="field__input field__input--select field__input--sm" name="inpTxtRentalState" id="inpTxtRentalState">
                      <option selected value="DIARIA">Diária</option>
                      <option value="UNITARIA">Unitária</option>
                      <option value="SEMANAL">Semanal</option>
                      <option value="MENSAL">Mensal</option>
                    </select>
                  </div>
                  <div class="rental-item-meta">
                    <span class="rental-item-meta__label">Preço/uni padrão</span>
                    <span class="rental-item-meta__value">R$ {{ item.unit_price }}</span>
                  </div>
                  <div v-show="dados.tableprice" class="rental-item-meta">
                    <span class="rental-item-meta__label">Novo Preço/uni:</span>
                    <span class="rental-item-meta__value">R$ {{ item.price }}</span>
                  </div>
                  <div class="rental-item-meta rental-item-meta--total">
                    <span class="rental-item-meta__label">Total</span>
                    <span class="rental-item-meta__value rental-item-meta__value--bold">R$ {{ item.total }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3 p-1" @click="openModal('modal_addItem')">
              <div class="rental-item-card rental-item-card--add">
                <div class="rental-item-card--add-icon">+</div>
                <span class="rental-item-card--add-label">Adicionar Item</span>
              </div>
            </div>

            <span v-if="errors.listaitens" class="field__feedback field__feedback--error mt-1">
              <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Adicione pelo menos um item à locação.
            </span>
          </div>

          <hr>

          <div class="field">
            <label for="inpTxtRentalState" class="field__label field__label--required">Usar tabela de preço?</label>
            <select @change="getTablePriceValues($event)" v-model="dados.tableprice" class="field__input field__input--select" name="inpTxtRentalState" id="inpTxtRentalState">
              <option selected :value="null">Padrão</option>
              <option v-for="tablePrice in listaTablePriceBD" :key="tablePrice.id" :value="tablePrice.id">
                {{ tablePrice.name }}
              </option>
            </select>
          </div>

          <hr>

          <!-- ===== DATAS ===== -->
          <div class="row mb-2">
            <h5 class="text-center mb-3">Datas:</h5>

            <div class="col-12 col-md-6">
              <div :class="['field', { 'field--error': errors.rental_date_start }]">
                <label for="inpDateStart" class="field__label field__label--required">Data de início</label>
                <input @change="calcDate" id="inpDateStart" class="field__input" type="date" v-model="dados.rental_date_start" />
                <span v-if="errors.rental_date_start" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.rental_date_start }}
                </span>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div :class="['field', { 'field--error': errors.rental_date_end }]">
                <label for="inpDateEnd" class="field__label field__label--required">Data final</label>
                <input @change="calcDate" id="inpDateEnd" class="field__input" type="date" v-model="dados.rental_date_end" />
                <span v-if="errors.rental_date_end" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.rental_date_end }}
                </span>
              </div>
            </div>

            <div class="col-12 col-md-6 mt-2">
              <div :class="['field', { 'field--error': errors.rental_time_start }]">
                <label for="inpTimeStart" class="field__label">Hora de início</label>
                <input @change="calcDate" id="inpTimeStart" class="field__input" type="time" v-model="dados.rental_time_start" />
                <span v-if="errors.rental_time_start" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.rental_time_start }}
                </span>
              </div>
            </div>

            <div class="col-12 col-md-6 mt-2">
              <div :class="['field', { 'field--error': errors.rental_time_end }]">
                <label for="inpTimeEnd" class="field__label">Hora final</label>
                <input @change="calcDate" id="inpTimeEnd" class="field__input" type="time" v-model="dados.rental_time_end" />
                <span v-if="errors.rental_time_end" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.rental_time_end }}
                </span>
              </div>
            </div>

            <div class="col-12 mt-3">
              <div class="rental-days-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                {{ dados.days_amount }} {{ dados.days_amount === 1 ? 'dia' : 'dias' }}
              </div>
            </div>

            <div class="col-12 col-md-6 mt-2">
              <div :class="['field', { 'field--error': errors.delivery_date }]">
                <label for="inpDateDelivery" class="field__label">Data de entrega/retirada</label>
                <input id="inpDateDelivery" class="field__input" type="date" v-model="dados.delivery_date" @input="onDeliveryDateInput" />
                <span v-if="errors.delivery_date" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.delivery_date }}
                </span>
                <span v-else class="field__feedback field__feedback--hint">
                  Lembrete de quando o equipamento deve ser entregue (ou retirado na loja). Padrão: 1 dia antes do início.
                </span>
              </div>
            </div>

            <div class="col-12 col-md-6 mt-2">
              <div :class="['field', { 'field--error': errors.pickup_date }]">
                <label for="inpDatePickup" class="field__label">Data de coleta/devolução</label>
                <input id="inpDatePickup" class="field__input" type="date" v-model="dados.pickup_date" @input="onPickupDateInput" />
                <span v-if="errors.pickup_date" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.pickup_date }}
                </span>
                <span v-else class="field__feedback field__feedback--hint">
                  Lembrete de quando o equipamento deve ser recolhido (ou devolvido pelo cliente). Padrão: 1 dia após o término.
                </span>
              </div>
            </div>
          </div>

          <hr>

          <!-- ===== FINANCEIRO ===== -->
          <div class="row mb-2">
            <h5 class="text-center mb-3">Financeiro:</h5>

            <div class="col-12 col-md-6">
              <div :class="['field', { 'field--error': errors.desconto }]">
                <label for="inpNumDesconto" class="field__label">Desconto (R$)</label>
                <div class="field__input-wrapper">
                  <input
                    @input="calcDesconto"
                    min="0" step="0.01" :max="dados.total_amount"
                    v-model="dados.discount"
                    type="number"
                    class="field__input"
                    style="padding-right: 48px;"
                    id="inpNumDesconto"
                  />
                  <span class="field__input-suffix">R$</span>
                </div>
                <span v-if="errors.desconto" class="field__feedback field__feedback--error">
                  <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {{ errors.desconto }}
                </span>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="field">
                <label for="inpNumDescontoPercent" class="field__label">Desconto (%)</label>
                <div class="field__input-wrapper">
                  <input
                    @input="calcPercent"
                    min="0" max="100"
                    v-model="dados.percent"
                    type="number"
                    class="field__input"
                    style="padding-right: 48px;"
                    id="inpNumDescontoPercent"
                  />
                  <span class="field__input-suffix">%</span>
                </div>
              </div>
            </div>

            <div class="col-12 mt-2">
              <div class="rental-summary-box">
                <div class="rental-summary-row">
                  <span class="rental-summary-row__label">Valor total</span>
                  <span class="rental-summary-row__value">R$ {{ dados.total_amount }}</span>
                </div>
                <div class="rental-summary-row rental-summary-row--final">
                  <span class="rental-summary-row__label">Valor final</span>
                  <span class="rental-summary-row__value rental-summary-row__value--highlight">R$ {{ dados.final_amount }}</span>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <!-- ===== CLIENTE ===== -->
          <div class="row mb-2">
            <h5 class="text-center mb-3">Cliente:</h5>

            <span v-if="errors.cliente" class="field__feedback field__feedback--error mb-2">
              <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {{ errors.cliente }}
            </span>

            <div v-if="dados.cliente.name !== 'AVULSO'" class="col p-1">
              <div class="rental-client-card">
                <div class="rental-client-card__avatar">{{ dados.cliente.name.charAt(0) }}</div>
                <div class="rental-client-card__info">
                  <p class="rental-client-card__name">{{ dados.cliente.name }}</p>
                  <span v-if="dados.cliente.cpf_cnpj" class="rental-client-card__meta">CPF/CNPJ: {{ dados.cliente.cpf_cnpj }}</span>
                  <span v-if="dados.cliente.city" class="rental-client-card__meta">Cidade: {{ dados.cliente.city }}</span>
                  <span v-if="dados.cliente.phone" class="rental-client-card__meta">Whatsapp: {{ dados.cliente.phone }}</span>
                  <span v-if="dados.cliente.email" class="rental-client-card__meta">E-mail: {{ dados.cliente.email }}</span>
                </div>
              </div>
            </div>

            <div class="col-auto p-1">
              <button type="button" class="rental-select-btn" @click="openModal('modal_selectClient')">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ dados.cliente.name === 'AVULSO' ? 'Selecionar Cliente' : 'Trocar Cliente' }}
              </button>
            </div>
          </div>

          <hr>

          <!-- ===== ENTREGA ===== -->
          <div class="row mb-2">
            <h5 class="text-center mb-3">Entrega:</h5>

            <div class="col-12 mb-3">
              <label class="rental-toggle-label">
                <input v-model="dados.withdrawal" class="rental-toggle-input" type="checkbox" value="true" id="checkDefault" />
                <span class="rental-toggle-track">
                  <span class="rental-toggle-thumb"></span>
                </span>
                <span class="rental-toggle-text">Retirada na loja</span>
              </label>
            </div>

            <div class="row p-0 m-0 mb-1" v-show="!dados.withdrawal">
              <div class="col-12 mb-2">
                <div class="field">
                  <label for="inpTxtRentalMapsLink" class="field__label">Link do Google Maps</label>
                  <div class="d-flex gap-2">
                    <input
                      v-model="mapsLink"
                      name="inpTxtRentalMapsLink"
                      type="text"
                      class="field__input"
                      id="inpTxtRentalMapsLink"
                      placeholder="Cole aqui o link do Google Maps (ex: https://maps.app.goo.gl/...)"
                      @keydown.enter.prevent="resolveMapsLink"
                    />
                    <button
                      type="button"
                      class="btn btn-secondary text-nowrap"
                      :disabled="mapsLoading"
                      @click="resolveMapsLink"
                    >
                      <span v-if="mapsLoading" class="spinner-border spinner-border-sm" role="status"></span>
                      <span v-else>Localizar</span>
                    </button>
                  </div>
                  <span class="field__feedback field__feedback--hint">
                    Cole o link compartilhado do Google Maps para preencher o endereço automaticamente.
                  </span>
                </div>
              </div>

              <div class="col-12">
                <div :class="['field', { 'field--error': errors.endereco }]">
                  <label for="inpTxtRentalEndereco" class="field__label field__label--required">Endereço</label>
                  <input :required="!dados.withdrawal" name="inpTxtRentalEndereco" v-model="dados.address" type="text" class="field__input" id="inpTxtRentalEndereco" placeholder="Rua, avenida..." />
                  <span v-if="errors.endereco" class="field__feedback field__feedback--error">
                    <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    {{ errors.endereco }}
                  </span>
                </div>
              </div>

              <div class="row p-0 m-0 mt-2">
                <div class="col-md col-sm-12 mb-2">
                  <div class="field">
                    <label for="inpTxtRentalBairro" class="field__label field__label--required">Bairro</label>
                    <input v-model="dados.neighbor" name="inpTxtRentalBairro" :required="!dados.withdrawal" type="text" class="field__input" id="inpTxtRentalBairro" placeholder="" />
                  </div>
                </div>
                <div class="col-md-3 col-sm-12 mb-2">
                  <div class="field">
                    <label for="inpTxtRentalNumer" class="field__label field__label--required">Número</label>
                    <input v-model="dados.number" name="inpTxtRentalNumer" :required="!dados.withdrawal" type="number" class="field__input" id="inpTxtRentalNumer" placeholder="" />
                  </div>
                </div>
              </div>

              <div class="row p-0 m-0 mt-2">
                <div class="col-md col-sm-12 mb-2">
                  <div :class="['field', { 'field--error': errors.cidade }]">
                    <label for="inpTxtRentalCity" class="field__label field__label--required">Cidade</label>
                    <input :required="!dados.withdrawal" v-model="dados.city" type="text" class="field__input" name="inpTxtRentalCity" id="inpTxtRentalCity" placeholder="" />
                    <span v-if="errors.cidade" class="field__feedback field__feedback--error">
                      <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      {{ errors.cidade }}
                    </span>
                  </div>
                </div>
                <div class="col-md col-sm-12 mb-2">
                  <div class="field">
                    <label for="inpTxtRentalState" class="field__label field__label--required">Estado</label>
                    <select :required="!dados.withdrawal" v-model="dados.state" class="field__input field__input--select" name="inpTxtRentalState" id="inpTxtRentalState">
                      <option value="" disabled selected>Selecione o Estado</option>
                      <option v-for="state in stateslist" :value="state.uf" :key="state.uf">{{ state.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-12 mb-2">
                  <div class="field">
                    <label for="inpTxtRentalCep" class="field__label">CEP</label>
                    <MaskInput mask="#####-###" v-model="dados.zipcode" type="text" class="field__input" id="inpTxtRentalCep" name="inpTxtRentalCep" placeholder="00000-000" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ===== OBSERVAÇÃO ===== -->
          <div class="row mt-1">
            <div class="field">
              <label for="inpTxtRentalObs" class="field__label">Observação</label>
              <textarea v-model="dados.note" class="field__input field__input--textarea" id="inpTxtRentalObs" name="inpTxtRentalObs" placeholder="Informações adicionais sobre a locação..."></textarea>
            </div>
          </div>

        </div>
        <div class="col-2"></div>
      </div>

      <!-- Botões -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/rental">Voltar</router-link>
          <button @click="actionOperation" class="btn btn-primary me-2">
            {{ operation === 'store' ? 'Salvar' : 'Atualizar' }}
          </button>
          <button @click="clearForm" type="button" class="btn btn-secondary me-2">Limpar</button>
        </div>
      </div>
      <div style="height: 90px;"></div>
    </form>

    <!-- Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados da locação...</p>
        <p class="mt-2" v-else-if="loading">Carregando...</p>
      </div>
    </div>

    <!-- Modal Adicionar Itens -->
    <div class="modal fade" id="modal_addItem" tabindex="-1" aria-labelledby="modalAddItemLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAddItemLabel">Adicionar item</h5>
            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-items-grid">
              <div
                v-for="item in listaItensBD"
                :key="item.id"
                class="modal-item-card"
                @click="select_item(item)"
              >
                <img :src="item.foto_url" class="modal-item-card__img" alt="" />
                <div class="modal-item-card__body">
                  <p class="modal-item-card__name">{{ item.name }}</p>
                  <span class="modal-item-card__price">R$ {{ item.unit_price }}</span>
                </div>
                <div class="modal-item-card__add">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Selecionar Cliente -->
    <div class="modal fade" id="modal_selectClient" tabindex="-1" aria-labelledby="modalClientLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalClientLabel">
              {{ open_newclient ? 'Cadastrar Cliente' : 'Selecionar Cliente' }}
            </h5>
            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <!-- Form novo cliente -->
            <div v-show="open_newclient">
              <form v-if="!loadingNewClient" @submit.prevent="actionCadCliente" @keydown.enter.prevent>
                <div class="col-12 mb-3">
                  <div class="form-check text-center">
                    <label class="form-label me-2">Tipo:</label>
                    <input value="PF" class="btn-check" type="radio" autocomplete="off" checked v-model="item.type" name="clientType" id="radioPF">
                    <label class="btn btn-outline-primary me-2" for="radioPF">PF</label>
                    <input value="PJ" class="btn-check" type="radio" autocomplete="off" v-model="item.type" name="clientType" id="radioPJ">
                    <label class="btn btn-outline-success" for="radioPJ">PJ</label>
                  </div>
                </div>
                <div class="field mb-2">
                  <label for="inpTxtClientNome" class="field__label field__label--required">Nome</label>
                  <input v-model="item.name" required type="text" class="field__input" id="inpTxtClientNome" placeholder="" />
                </div>
                <div class="field mb-2">
                  <label for="inpTxtClientWhats" class="field__label field__label--required">Whatsapp</label>
                  <input v-model="item.phone" required type="text" class="field__input" id="inpTxtClientWhats" placeholder="" />
                </div>
                <div class="field mb-3">
                  <label for="inpTxtClientEmail" class="field__label">E-mail</label>
                  <input v-model="item.email" type="email" class="field__input" id="inpTxtClientEmail" placeholder="" />
                </div>
                <div>
                  <button type="submit" class="btn btn-success me-2">Salvar</button>
                  <button type="button" @click="openNewClient()" class="btn btn-secondary">Cancelar</button>
                </div>
              </form>
              <div v-else class="d-flex justify-content-center p-3">
                <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>

            <!-- Lista de clientes -->
            <div v-show="!open_newclient">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Whatsapp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in listaClientesBD" :key="item.id" @click="selectClient(item)">
                    <td class="itemclienteslist" scope="row">{{ item.id }}</td>
                    <td class="itemclienteslist">{{ item.name }}</td>
                    <td class="itemclienteslist">{{ item.phone }}</td>
                  </tr>
                </tbody>
              </table>
              <button class="btn btn-primary" type="button" @click="openNewClient()">
                + Novo Cliente
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal Loading -->
    <div class="modal fade" id="modal_loading" tabindex="-1" aria-labelledby="modalClientLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex justify-content-center p-3">
              <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { onBeforeMount, onMounted, reactive, ref } from 'vue';
import { Modal } from "bootstrap";
import { rental } from '@/models/rental';
import { itens } from '@/models/itens';
import { clientes } from '@/models/clientes';
import { tableprice } from '@/models/tableprice';
import { maps } from '@/models/maps';
import { MaskInput } from 'vue-3-mask';
import { useRouter } from 'vue-router';
import states from '@/services/states.js';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import { usePermissions } from '@/composables/usePermissions';

export default {
  name: "NewRentalView",
  components: {
    PainelLayout,
    Breadcrumb,
    MaskInput
  },
  setup(props) {

    const toastStore = useToastStore();
    const { isOpeto } = usePermissions();
    let modal = '';
    var loading = ref(false);
    var loadingNewClient = ref(false);
    var operation = ref('store');
    const model = rental();
    const getStates = states.get();
    const stateslist = getStates;

    var open_newclient = ref(false);
    const router = useRouter();

    const modelitens = itens();
    const modelclientes = clientes();
    const modeltableprice = tableprice();
    const modelmaps = maps();
    const mapsLink = ref('');
    const mapsLoading = ref(false);
    const listaClientesBD = ref([]);
    const listaItensBD = ref([]);
    const listaTablePriceBD = ref([]);

    var tablePriceSelect = ref([]);

    let date = new Date();
    let idEditing = null;

    // true assim que o usuário mexe manualmente no campo — evita que o cálculo
    // automático (calcDate) sobrescreva um valor já ajustado à mão.
    var deliveryTouched = ref(false);
    var pickupTouched = ref(false);

    function formatISODate(d) {
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    function addDays(dateStr, days) {
      const d = new Date(`${dateStr}T00:00:00`);
      d.setDate(d.getDate() + days);
      return formatISODate(d);
    }

    // Sábado/domingo não são dias úteis pra entrega/coleta: se o cálculo padrão
    // (1 dia antes/depois do evento) cair num fim de semana, a entrega recua pra
    // sexta-feira anterior e a coleta avança pra segunda-feira seguinte.
    function defaultDeliveryDate(startDate) {
      const d = new Date(`${addDays(startDate, -1)}T00:00:00`);
      const day = d.getDay(); // 0 = domingo, 6 = sábado
      if (day === 6) d.setDate(d.getDate() - 1);
      else if (day === 0) d.setDate(d.getDate() - 2);
      return formatISODate(d);
    }

    function defaultPickupDate(endDate) {
      const d = new Date(`${addDays(endDate, 1)}T00:00:00`);
      const day = d.getDay();
      if (day === 6) d.setDate(d.getDate() + 2);
      else if (day === 0) d.setDate(d.getDate() + 1);
      return formatISODate(d);
    }

    var item = reactive({
      name: '',
      phone: '',
      email: '',
      type: 'PF'
    })

    var errors = reactive({
      cliente: false,
      listaitens: false,
      rental_date_start: false,
      rental_date_end: false,
      rental_time_start: false,
      rental_time_end: false,
      delivery_date: false,
      pickup_date: false,
      desconto: false,
      cidade: false,
      endereco: false,
    })

    var dados = reactive({
      cliente: {name:'AVULSO'},
      listaitens: [],
      tableprice: null,
      discount: 0,
      percent: 0,
      total_amount: 0,
      final_amount: 0,
      rental_date_start: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
      rental_time_start: '00:00',
      rental_date_end: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
      rental_time_end: '23:59',
      delivery_date: defaultDeliveryDate(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`),
      pickup_date: defaultPickupDate(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`),
      days_amount: 1,
      withdrawal: false,
      address: '',
      number: '',
      neighbor: '',
      city: '',
      state: '',
      zipcode: '',
      latitude: null,
      longitude: null,
      note: ''
    })

    async function refreshItensBD(){
      listaItensBD.value = await modelitens.list();
    }

    async function refreshClientesBD(){
      listaClientesBD.value = await modelclientes.list();
    }

    async function refreshTablePriceBD(){
      listaTablePriceBD.value = await modeltableprice.list();
    }

    async function getTablePriceValues(){
      if (dados.tableprice !== null) {
        openModal('modal_loading');
        const retorno = await modeltableprice.getOne(dados.tableprice);
        tablePriceSelect.value = retorno.items;
        aplicarValores();
      } else {
        tablePriceSelect.value = [];
        defaltaValores();
      }
      closeModal();
      calcValores();
    }

    function defaltaValores() {
      dados.listaitens.forEach(item => {
        item.price = parseFloat(item.unit_price).toFixed(2);
      });
    }

    function aplicarValores() {
      dados.listaitens.forEach(item => {
        var price = tablePriceSelect.value.find(i => i.item.id === item.id);
        if(price){
          item.price = parseFloat(price.price).toFixed(2);
        }
      });
    }

    function select_item(item) {
      const existingItem = dados.listaitens.find(obj => obj.id === item.id);
      if (existingItem) {
        existingItem.quant = existingItem.quant + 1;
      } else {
        var add = {
          'id' : item.id,
          'id_rental_item' : null,
          'id_rental' : null,
          'foto_url' : item.foto_url,
          'name' : item.name,
          'quant' : 1,
          'unit_price' : item.unit_price.toFixed(2),
          'price' : item.unit_price.toFixed(2),
          'total' : 0,
          'rental_type' : 'DIARIA',
        }
        dados.listaitens.push(add)
      }
      errors.listaitens = false;
      closeModal();
      if (dados.tableprice) {
        aplicarValores();
      }
      calcValores();
    }

    function selectClient(item) {
      dados.cliente = item;
      errors.cliente = false;
      closeModal();
    }

    function addItem(id) {
      dados.listaitens.forEach(item => {
        if (item.id === id) item.quant = item.quant + 1;
      });
      calcValores();
    }

    function removeItem(id) {
      dados.listaitens.forEach(item => {
        if (item.id === id) {
          if (item.quant > 0) {
            item.quant = item.quant - 1;
            if (item.quant == 0) excludeItem(id);
          } else {
            excludeItem(id);
          }
        }
      });
      calcValores();
    }

    function excludeItem(id) {
      dados.listaitens.forEach(item => {
        if (item.id === id) {
          const index = dados.listaitens.indexOf(item);
          dados.listaitens.splice(index, 1);
        }
      });
      calcValores();
    }

    function clearForm() {
      dados.cliente = {name:'AVULSO'};
      dados.listaitens = [];
      dados.discount = 0;
      dados.percent = 0;
      dados.total_amount = 0;
      dados.final_amount = 0;
      dados.rental_date_start = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      dados.rental_time_start = '00:00';
      dados.rental_date_end = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      dados.rental_time_end = '23:59';
      dados.delivery_date = defaultDeliveryDate(dados.rental_date_start);
      dados.pickup_date = defaultPickupDate(dados.rental_date_end);
      deliveryTouched.value = false;
      pickupTouched.value = false;
      dados.days_amount = 1;
      dados.withdrawal = false;
      dados.address = '';
      dados.number = '';
      dados.neighbor = '';
      dados.city = '';
      dados.state = '';
      dados.zipcode = '';
      dados.latitude = null;
      dados.longitude = null;
      dados.note = '';
      mapsLink.value = '';
    }

    // Extrai a latitude/longitude de um link do Google Maps (via backend, que
    // segue o redirecionamento de links curtos) e usa o Nominatim (OSM) para
    // preencher o endereço a partir das coordenadas.
    async function resolveMapsLink() {
      const link = mapsLink.value.trim();
      if (!link) {
        toastStore.warning('Cole um link do Google Maps primeiro.');
        return;
      }

      mapsLoading.value = true;
      try {
        const coords = await modelmaps.resolveLink(link);
        dados.latitude = coords.latitude;
        dados.longitude = coords.longitude;

        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${coords.latitude}&lon=${coords.longitude}&accept-language=pt-BR`;
        const response = await fetch(url);
        const result = await response.json();
        const addr = result?.address || {};

        dados.address = addr.road || addr.pedestrian || addr.residential || dados.address;
        dados.number = addr.house_number || dados.number;
        dados.neighbor = addr.suburb || addr.neighbourhood || addr.city_district || dados.neighbor;
        dados.city = addr.city || addr.town || addr.village || addr.municipality || dados.city;
        dados.state = (addr['ISO3166-2-lvl4'] || '').split('-')[1] || dados.state;
        dados.zipcode = addr.postcode || dados.zipcode;

        toastStore.success('Localização encontrada! Confira o endereço preenchido abaixo.');
      } catch (error) {
        toastStore.error('Erro ao localizar endereço: ' + parseError(error));
      } finally {
        mapsLoading.value = false;
      }
    }

    function calcTotalItem(event, id) {
      const quant = event.target.value;
      if (quant < 1) {
        excludeItem(id);
        return;
      }
      dados.listaitens.forEach(item => {
        if (item.id === id) item.quant = quant;
      });
      calcValores();
    }

    function calcValores() {
      dados.listaitens.forEach(item => {
        let subtotal = 0;
        const preco = parseFloat(item.price) || 0;
        const quant = parseInt(item.quant) || 0;
        const dias = parseInt(dados.days_amount) || 1;

        switch (item.rental_type) {
          case 'DIARIA':
            subtotal = (preco * dias) * quant;
            break;
          case 'SEMANAL':
            subtotal = (preco * Math.ceil(dias / 7)) * quant;
            break;
          case 'MENSAL':
            subtotal = (preco * Math.ceil(dias / 30)) * quant;
            break;
          case 'UNITARIA':
            subtotal = preco * quant;
            break;
        }

        item.total = subtotal.toFixed(2); 
      });

      let totalGeral = 0;
      dados.listaitens.forEach(item => {
        totalGeral += parseFloat(item.total);
      });

      dados.total_amount = totalGeral.toFixed(2);
      calcDesconto();
    }

    function calcDesconto() {
      const total = parseFloat(dados.total_amount) || 0;
      const desconto = parseFloat(dados.discount) || 0;

      if (desconto > total) {
        toastStore.warning("O valor do desconto não pode ser maior que o valor total!");
        errors.desconto = "O desconto não pode ser maior que o valor total.";
        dados.discount = 0;
        dados.percent = 0;

        calcValores(); 
        return;
      }

      errors.desconto = false;

      const resultadoFinal = total - desconto;
      dados.final_amount = resultadoFinal.toFixed(2);
    }

    function calcPercent() {
      const total = parseFloat(dados.total_amount) || 0;
      const percent = parseFloat(dados.percent) || 0;

      if (percent < 0 || percent > 100) {
        toastStore.warning("A porcentagem de desconto deve estar entre 0% e 100%.");
        errors.desconto = "A porcentagem deve ser entre 0 e 100.";
        dados.percent = 0;
        dados.discount = 0;

        calcValores(); 
        return;
      }

      errors.desconto = false;

      const descontoCalculado = (total * percent) / 100;
      dados.discount = descontoCalculado.toFixed(2);
      calcDesconto();
    }

    function calcDate() {
      const inicio = new Date(`${dados.rental_date_start}T${dados.rental_time_start}`);
      const fim = new Date(`${dados.rental_date_end}T${dados.rental_time_end}`);
      const difDias = ((fim - inicio) / (1000 * 60 * 60)) / 24;
      const final = Math.ceil(difDias);
      if (final <= 0) {
        errors.rental_date_end = "A data final deve ser posterior à data de início.";
        dados.days_amount = 1;
      } else {
        errors.rental_date_end = false;
        dados.days_amount = final;
      }

      // Recalcula os lembretes de entrega/coleta enquanto o usuário não tiver
      // ajustado esses campos manualmente.
      if (!deliveryTouched.value && dados.rental_date_start) {
        dados.delivery_date = defaultDeliveryDate(dados.rental_date_start);
      }
      if (!pickupTouched.value && dados.rental_date_end) {
        dados.pickup_date = defaultPickupDate(dados.rental_date_end);
      }

      validateDeliveryPickup();
      calcValores();
    }

    // Datas são strings "YYYY-MM-DD" (ISO), então dá pra comparar como texto mesmo.
    function validateDeliveryPickup() {
      errors.delivery_date = (dados.delivery_date && dados.rental_date_start && dados.delivery_date > dados.rental_date_start)
        ? 'A data de entrega não pode ser depois da data de início do evento.'
        : false;

      errors.pickup_date = (dados.pickup_date && dados.rental_date_end && dados.pickup_date < dados.rental_date_end)
        ? 'A data de coleta não pode ser antes da data de término do evento.'
        : false;
    }

    function onDeliveryDateInput() {
      deliveryTouched.value = true;
      validateDeliveryPickup();
    }

    function onPickupDateInput() {
      pickupTouched.value = true;
      validateDeliveryPickup();
    }

    function openNewClient() {
      open_newclient.value = !open_newclient.value;
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        store();
      }
    }

    const actionCadCliente = () => {
      loadingNewClient.value = true;
      modelclientes.store(item).then((response) => {
        closeModal();
        open_newclient.value = false;
        refreshClientesBD();
        toastStore.success('Cliente cadastrado com sucesso!');
        openModal('modal_selectClient');
        loadingNewClient.value = false;
      }).catch((error) => {
        loadingNewClient.value = false;
        toastStore.error('Erro ao criar novo cliente: ' + parseError(error));
      });
    }

    function requisitos() {
      let valid = true;
      if (!dados.listaitens.length > 0) {
        errors.listaitens = true;
        valid = false;
      }
      validateDeliveryPickup();
      if (errors.delivery_date || errors.pickup_date) {
        valid = false;
      }
      return valid;
    }

    function store() {
      if (!requisitos()) {
        if (errors.listaitens) {
          toastStore.warning('Por favor, adicione pelo menos um item à locação.');
        } else if (errors.delivery_date || errors.pickup_date) {
          toastStore.warning('Corrija as datas de entrega/coleta antes de continuar.');
        }
        return;
      }
      loading.value = true;

      const dadosPos = {
        'id_client' : dados.cliente.id,
        'listaitens': dados.listaitens,
        'id_price_table': dados.tableprice,
        'discount': dados.discount,
        'percent': dados.percent,
        'total_amount': dados.total_amount,
        'final_amount': dados.final_amount,
        'rental_date_start': `${dados.rental_date_start}T${dados.rental_time_start}`,
        'rental_date_end': `${dados.rental_date_end}T${dados.rental_time_end}`,
        'delivery_date': dados.delivery_date || null,
        'pickup_date': dados.pickup_date || null,
        'days_amount': dados.days_amount,
        'withdrawal': dados.withdrawal ? 1 : 0,
        'address': dados.address,
        'number': Number(dados.number),
        'neighbor': dados.neighbor,
        'city': dados.city,
        'state': dados.state,
        'zipcode': dados.zipcode,
        'latitude': dados.latitude,
        'longitude': dados.longitude,
        'note': dados.note
      }

      model.store(dadosPos).then((response) => {
        toastStore.success('Locação lançada com sucesso!');
        router.push('/rental/details?id=' + response.id);
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao lançar nova locação: ' + parseError(error));
      });
    }

    function update() {
      validateDeliveryPickup();
      if (errors.delivery_date || errors.pickup_date) {
        toastStore.warning('Corrija as datas de entrega/coleta antes de continuar.');
        return;
      }
      loading.value = true;

      const dadosPos = {
        'id' : idEditing,
        'id_client' : dados.cliente.id,
        'id_price_table': dados.tableprice,
        'items': dados.listaitens,
        'discount': dados.discount,
        'percent': dados.percent,
        'total_amount': dados.total_amount,
        'final_amount': dados.final_amount,
        'rental_date_start': `${dados.rental_date_start}T${dados.rental_time_start}`,
        'rental_date_end': `${dados.rental_date_end}T${dados.rental_time_end}`,
        'delivery_date': dados.delivery_date || null,
        'pickup_date': dados.pickup_date || null,
        'days_amount': dados.days_amount,
        'withdrawal': dados.withdrawal ? 1 : 0,
        'address': dados.address,
        'number': Number(dados.number),
        'neighbor': dados.neighbor,
        'city': dados.city,
        'state': dados.state,
        'zipcode': dados.zipcode,
        'latitude': dados.latitude,
        'longitude': dados.longitude,
        'note': dados.note
      }

      model.update(dadosPos).then((response) => {
        toastStore.success('Locação atualizada com sucesso!');
        router.push('/rental/details?id=' + idEditing);
      }).catch((error) => {
        toastStore.error('Erro ao atualizar locação: ' + parseError(error));
        loading.value = false;
      });
    }

    onBeforeMount(() => {
      // Operador não tem permissão pra criar/editar locação (backend recusa
      // store/edit com 403) — manda de volta pra listagem antes mesmo de carregar.
      if (isOpeto.value) {
        toastStore.warning('Você não tem permissão para acessar esta página.');
        router.push('/rental');
      }
    });

    onMounted(function () {
      refreshItensBD();
      refreshClientesBD();
      refreshTablePriceBD();

      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = "Atualizar Locação - AlugaSoft";
        idEditing = id;
        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          dados.cliente = response.client ?? {name: 'AVULSO'}; // locação sem cliente vinculado (venda avulsa)
          dados.tableprice = response.price_table?.id ?? null;
          dados.listaitens = response.items;
          dados.discount = response.discount;
          dados.percent = response.percent;
          dados.total_amount = response.total_amount;
          dados.final_amount = response.final_amount;
          dados.rental_date_start = response.rental_date_start.split(' ')[0];
          dados.rental_time_start = response.rental_date_start.split(' ')[1].slice(0,5);
          dados.rental_date_end = response.rental_date_end.split(' ')[0];
          dados.rental_time_end = response.rental_date_end.split(' ')[1].slice(0,5);
          if (response.delivery_date) {
            dados.delivery_date = response.delivery_date.split(' ')[0];
            deliveryTouched.value = true; // já veio definida do backend, não sobrescrever ao mexer nas datas do evento
          } else {
            dados.delivery_date = defaultDeliveryDate(dados.rental_date_start);
          }
          if (response.pickup_date) {
            dados.pickup_date = response.pickup_date.split(' ')[0];
            pickupTouched.value = true;
          } else {
            dados.pickup_date = defaultPickupDate(dados.rental_date_end);
          }
          dados.days_amount = response.days_amount;
          dados.withdrawal = response.withdrawal == 1 ? true : false;
          dados.address = response.address;
          dados.number = response.number;
          dados.neighbor = response.neighbor;
          dados.city = response.city;
          dados.state = response.state;
          dados.zipcode = response.zipcode;
          dados.latitude = response.latitude;
          dados.longitude = response.longitude;
          dados.note = response.note;
          if (dados.tableprice) {
            getTablePriceValues()
          }
          validateDeliveryPickup();
          calcValores();
          loading.value = false;
        }).catch((error) => {
          loading.value = false;
          toastStore.error('Erro ao carregar locação: ' + parseError(error));
        });
      }
    });

    return {
      item,
      dados,
      stateslist,
      actionOperation,
      actionCadCliente,
      closeModal,
      openModal,
      operation,
      loading,
      loadingNewClient,
      addItem,
      removeItem,
      select_item,
      selectClient,
      listaItensBD,
      listaClientesBD,
      calcPercent,
      calcDesconto,
      calcValores,
      open_newclient,
      openNewClient,
      calcDate,
      calcTotalItem,
      onDeliveryDateInput,
      onPickupDateInput,
      errors,
      clearForm,
      listaTablePriceBD,
      getTablePriceValues,
      mapsLink,
      mapsLoading,
      resolveMapsLink,
      calcPercent
    }
  }
}
</script>

<style scoped>

/* ===== Badge de dias ===== */
.rental-days-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
}

/* ===== Box financeiro ===== */
.rental-summary-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rental-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rental-summary-row--final {
  border-top: 1px solid #e5e7eb;
  padding-top: 8px;
  margin-top: 2px;
}
.rental-summary-row__label {
  font-size: 13px;
  color: #6b7280;
}
.rental-summary-row__value {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}
.rental-summary-row__value--highlight {
  font-size: 18px;
  font-weight: 700;
  color: #16a34a;
}

/* ===== Card cliente ===== */
.rental-client-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.rental-client-card__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rental-client-card__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.rental-client-card__name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.rental-client-card__meta {
  font-size: 12px;
  color: #6b7280;
  display: block;
}

/* Botão selecionar cliente */
.rental-select-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  white-space: nowrap;
}
.rental-select-btn:hover { border-color: #1a73e8; color: #1a73e8; background: #f0f7ff; }

/* ===== Toggle retirada ===== */
.rental-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}
.rental-toggle-input { display: none; }
.rental-toggle-track {
  width: 40px;
  height: 22px;
  background: #d1d5db;
  border-radius: 11px;
  position: relative;
  transition: background 0.2s;
  flex-shrink: 0;
}
.rental-toggle-input:checked + .rental-toggle-track { background: #1a73e8; }
.rental-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}
.rental-toggle-input:checked + .rental-toggle-track .rental-toggle-thumb { left: 21px; }
.rental-toggle-text { font-size: 14px; color: #374151; font-weight: 500; }

</style>